import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { styled, useThemeProps, } from '../../foundation';
import { RcIcon } from '../Icon';
import { Unattended, Dnd, Check, Offline, Default } from './assets';
import { StyledPresence, PresenceContainer } from './styles';
import { RcPresenceColors, RcPresenceSizes } from './utils';
var _RcPresence = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcPresence' });
    var type = props.type, color = props.color, size = props.size, borderSize = props.borderSize, rest = __rest(props, ["type", "color", "size", "borderSize"]);
    var sizeProps = {
        iconSizeValue: RcPresenceSizes[size][0],
        borderSizeValue: RcPresenceSizes[borderSize || size][1],
        type: type,
    };
    var symbol = (function () {
        switch (type) {
            case 'DND':
                return Dnd;
            case 'available':
            case 'attended':
                return Check;
            case 'unAttended':
                return Unattended;
            case 'offline':
            case 'unavailable':
            case 'notReady':
                return Offline;
            default:
                return Default;
        }
    })();
    return (React.createElement(PresenceContainer, __assign({ ref: ref }, sizeProps, rest),
        React.createElement(StyledPresence, __assign({}, sizeProps, { color: color }),
            React.createElement(RcIcon, { symbol: symbol, color: color || RcPresenceColors[type], size: "inherit" }))));
});
/** @release */
var RcPresence = styled(_RcPresence)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
RcPresence.defaultProps = {
    size: 'xsmall',
    type: 'notReady',
};
RcPresence.displayName = 'RcPresence';
export { RcPresence };
var templateObject_1;
